import { FC } from 'react';
import { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { taskWidgetTrackingIds } from '@frontend/task-center-components';
import { ContentSwitcher, Text } from '@frontend/design-system';
import { useDashboardWidgetStore } from '../../../provider/dashboard-provider/dashboard-widget.provider';

export const ProgressSwitcher: FC = () => {
  const { t } = useTranslation('task-center');
  const { status, setStatus } = useDashboardWidgetStore(['status', 'setStatus']);

  return (
    <ContentSwitcher<TaskStatus> defaultValue={status} aria-label={t('Progress Switcher')} onValueChange={setStatus}>
      <ContentSwitcher.Option
        value={TaskStatus['STATUS_TODO']}
        trackingId={taskWidgetTrackingIds.progressSwitcherProgressTodo}
      >
        <Icon name='pending-small' /> <Text>{t('Todo')}</Text>
      </ContentSwitcher.Option>
      <ContentSwitcher.Option
        value={TaskStatus['STATUS_IN_PROGRESS']}
        trackingId={taskWidgetTrackingIds.progressSwitcherInProgress}
      >
        <Icon name='in-progress-small' /> <Text>{t('In Progress')}</Text>
      </ContentSwitcher.Option>
    </ContentSwitcher>
  );
};
